import ozOZ from "date-fns/locale/uz-Cyrl";

const ShortLinks = {
  month: "Бир ойда",
  threeMonths: "Уч ойда",
  sixMonths: "Ярим йилда",
  year: "Бир йилда",
};

const DateTimeFormats = {
  sunday: "Я",
  monday: "Д",
  tuesday: "С",
  wednesday: "Ч",
  thursday: "П",
  friday: "Ж",
  saturday: "Ш",
  ok: "OK",
  today: "Бугун",
  yesterday: "Кеча",
  now: "Ҳозир",
  hours: "Соатлар",
  minutes: "Дақиқалар",
  seconds: "Сониялар",
  formattedMonthPattern: "MMM yyyy",
  formattedDayPattern: "dd MMM yyyy",
  shortDateFormat: "dd/MM/yyyy",
  shortTimeFormat: "HH:mm",
  dateLocale: ozOZ,
};

const Combobox = {
  noResultsText: "Ҳеч қандай натижа топилмади",
  placeholder: "Танланг",
  searchPlaceholder: "Излаш",
  checkAll: "Ҳаммаси",
};

const CreatableComboBox = {
  ...Combobox,
  newItem: "Янги элемент",
  createOption: '"{0}" вариантини яратиш',
};

export const uz = {
  code: "oz",
  common: {
    loading: "Юкланмоқда...",
    emptyMessage: "Маълумот топилмади",
    remove: "Ўчириш",
    clear: "Тозалаш",
  },
  Plaintext: {
    unfilled: "Тўлдирилмаган",
    notSelected: "Танланмаган",
    notUploaded: "Юкланмаган",
  },
  Pagination: {
    more: "Кўпроқ",
    prev: "Олдинги",
    next: "Кейинги",
    first: "Биринчи",
    last: "Охирги",
    limit: "{0} / саҳифа",
    total: "Жами саатрлар: {0}",
    skip: "{0} га ўтиш",
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: "Сўнгги 7 кун",
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: "Ишга туширилган",
    progress: "Юкланмоқда",
    error: "Хатолик",
    complete: "Тўлиқ",
    emptyFile: "Бўш файл",
    upload: "Юклаш",
    removeFile: "Файлни ўчириш",
  },
  CloseButton: {
    closeLabel: "Ёпиш",
  },
  Breadcrumb: {
    expandText: "Йўлни кўрсатиш",
  },
  Toggle: {
    on: "Очиш",
    off: "Ёпиш",
  },
  ShortLinks,
};
